import pagamento from './pagamento'
import recebimento from './recebimento'
import accountFiles from './accountFiles'
import emprestimo from './emprestimo'
import report from './report'
import transacoes from './transacoes'
import contabil from './contabil'
import contas from './contas'
import ajusteConta from './ajusteConta'
import mensalidades from './mensalidades'
import negociacao from './negociacao'
import integracoes from './integracoes'

export default [
  ...pagamento,
  ...recebimento,
  ...accountFiles,
  ...emprestimo,
  ...negociacao,
  ...report,
  ...transacoes,
  ...contabil,
  ...contas,
  ...ajusteConta,
  ...mensalidades,
  ...integracoes,
]
